import { useIsMobileViewport } from "@solomon-apps/shared";

/**
 * The client console treats mobile as a **view-only** surface.
 *
 * It's a B2B product whose mutation flows (compliance onboarding, adding
 * and editing positions, inviting teammates) are multi-step and
 * desktop-first — wallet signing, document upload, Squads detection. On a
 * phone those actions are disabled and the user is pointed to desktop,
 * while everything read-only (portfolio, reporting, policies, accounts)
 * stays fully usable.
 *
 * Returns `true` below the `md` breakpoint and reacts to resize /
 * orientation change. Pair with `ViewOnlyHint` (inline note beside a
 * disabled action) or `DesktopOnly` (full-page placeholder for a
 * mutation-only route).
 */
export function useViewOnly(): boolean {
    return useIsMobileViewport();
}
